module.exports = __webpack_public_path__ + "img/20_kiwi.b2a4f936.jpg";